<template>
    <div id="noneligibleFeaturepop" >
        <AppModal v-model="noneligibleVisible" noCloseOnBackdrop position="center" ref="noneligeble">
            <div class="w-100 flex justify-end p-16">
                <span class="cursor-pointer" @click="hidemodal()">
                    <el-icon :size="24"><Close /></el-icon>
                </span>
            </div>
            
            <div class="clearfix" v-if="loading">
                <div class="w-100">
                <div class="loader"></div>
                <p class="text-mediumgrey fw-bold text-center">Vi sender en besked til vores support team</p>
                </div>
            </div>
            
            <div class="clearfix bg-white p-16" v-else>
                <div class="flex flex-col w-100">
                <div class="fs-20 mb-16 text-darkblue text-center fw-bold">Hej {{partnername}} !</div>
                <div class="fs-16 mb-16 text-darkblue text-center fw-semibold">Denne funktion er ikke en del af dit abonnement. Opgrader nu for fuld adgang.</div>
                <div class="fs-16 mb-16 text-darkblue text-center text-center">Hvis du allerede har købt denne funktion, skal du gå til forsiden og vende tilbage til denne side.</div>
                <div class="w-100 flex gap-16 p-0">
                    <button @click="hidemodal('')" :disabled="buttondisabled" class="w-50 outlined-easternblue-button rounded-6 text-white p-16 fs-16 fw-regular">Nej tak</button>
                    <button @click="requestBitrixFeatures()" :disabled="buttondisabled" class="w-50 easternblue-button rounded-6 text-white p-16 fs-16 fw-regular">
                    <span class="ml-32 mr-32">Opgradér</span>
                    </button>
                </div>
                </div>
            </div>
        </AppModal>
        <AppModal v-model="successVisible" noCloseOnBackdrop position="center" ref="successrequestfeature">
            <div class="clearfix bg-white p-24 xs-p-16">
                <div class="text-center w-100">
                <p class="mb-16 text-darkblue mx-auto"><el-icon class="text-green" style="font-size:4em"><DocumentChecked /></el-icon></p>
                <p class="fw-semibold fs-24 text-darkblue">Tak for din henvendelse,</p>
                <p class="fs-20 text-darkblue">Vi ringer til dig hurtigst muligt</p>
                <button @click="hidemodaltak('')" class="w-100 fs-20 easternblue-button rounded-6 text-white no-border not-rounded flex justify-center items-center">Luk</button>
                </div>
            </div>
            <!-- <div class="w-100 p-16 bg-white"><p>_</p></div> -->
        </AppModal>
    </div>
</template>
<script setup>
import { ElIcon } from 'element-plus'
import { Close, DocumentChecked } from '@element-plus/icons-vue'
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from 'axios'
import AppModal from '@/components/AppModal.vue'

const props = defineProps({
    eligibilitydata: {
        type: [Object, Array, String],
        required: false,
        default: null
    }
})

const router = useRouter()
const route = useRoute()

// State
const partnername = ref('')
const partnerData = ref({})
const salesPerson = ref('')
const loadingrUpgrade = ref(false)
const haaid = ref('')
const packagehandle = ref('')
const partneremail = ref('')
const partnertelephone = ref('')
const actualfeaturecode = ref([])
const wheretogo = ref('')
const loading = ref(false)
const buttondisabled = ref(false)
const noneligibleVisible = ref(false)
const successVisible = ref(false)

onMounted(() => {
    salesPerson.value = localStorage.getItem('id_token_portalbitrix')
    partnername.value = localStorage.getItem('CompanyName')
    haaid.value = localStorage.getItem('haaid')
    packagehandle.value = localStorage.getItem('PartnerPackageHandle')
    if (typeof packagehandle.value === 'undefined' || packagehandle.value === null) {
        if (route.name !== 'receiveSubcontract') {
            getbitrixinfo()
        }
    }
})

function showmodel(iseligible, directto = '', featurecode = '') {
    partnerData.value['eligible'] = iseligible
    if (directto !== '') {
        partnerData.value['linkreferer'] = directto
    } else {
        partnerData.value['linkreferer'] = route.fullPath
    }
    actualfeaturecode.value.push(featurecode)
    noneligibleVisible.value = true
}

function hidemodal(togohide = '') {
    noneligibleVisible.value = false
    if (togohide === '') {
        goto()
    }
}

function hidemodaltak(togohide = '') {
    successVisible.value = false
    if (togohide === '') {
        goto()
    }
}

function goto() {
    router.push(partnerData.value['linkreferer'])
}

function getPartner() {
    const sp = localStorage.getItem('id_token_portal')
    const hId = localStorage.getItem('haaid')
    const data = { operation: 'oversigt_partner_haa', salesPerson: sp, levid: hId }
    axios.post('', data).then(
        response => {
            const res = response.data
            partnertelephone.value = res.Telefon
            partnername.value = res.Firma
            partneremail.value = res.Email
            buttondisabled.value = false
            if (typeof packagehandle.value === 'undefined' || packagehandle.value === null) {
                getbitrixinfo()
            }
        },
        response => {
            console.error('error', response)
        }
    )
}

function getbitrixinfo() {
    const hId = localStorage.getItem('haaid')
    axios.get(import.meta.env.VITE_BITRIXAPI + 'bitrix/getPackage/' + hId).then(
        (response) => {
            const res = response.data
            if (res.success) {
                packagehandle.value = res.data.PACKAGE_HANDLE
                buttondisabled.value = false
            } else {
                loading.value = false
                console.error(res.message)
            }
        },
        (response) => {
            loading.value = false
            const error = response.data.message
            console.error(error)
        }
    )
}

function requestBitrixFeatures() {
    partnertelephone.value = localStorage.getItem('PartnerTelefon')
    partnername.value = localStorage.getItem('CompanyName')
    partneremail.value = localStorage.getItem('email')
    loading.value = true
    const headers = { Authorization: 'Bearer ' + salesPerson.value }
    const data = {
        company_id: haaid.value,
        company_name: partnername.value,
        name: partnername.value,
        email: partneremail.value,
        phone: partnertelephone.value,
        features: actualfeaturecode.value,
        package_name: packagehandle.value,
        requestFrom: 'Web'
    }
    axios.post(import.meta.env.VITE_BITRIXAPI + 'bitrix/requestBitrixFeatures', data, { headers }).then(
        (response) => {
            const res = response.data
            if (res.success) {
                hidemodal('success')
                successVisible.value = true
                wheretogo.value = 'success'
                loading.value = false
            }
        },
        (response) => {
            loading.value = false
            const error = response.data.message
            console.error(error)
        }
    )
}

function upgradeOfferVaekstplus(id = null) {
    loadingrUpgrade.value = true
    const headers = {
        Authorization: 'Bearer ' + salesPerson.value,
        'x-localization': 'da'
    }
    const data = { dead_id: id }
    axios.post(import.meta.env.VITE_BITRIXAPI + 'partner/upgradeOfferVaekstplus', data, { headers }).then(
        response => {
            const res = response.data.data
            const redirectUrl = res.data.CONFIRM_URL
            window.location.href = redirectUrl
        },
        (response) => {
            loadingrUpgrade.value = false
            const error = response.data.message
            console.error(error)
        }
    )
}

function acceptUpgradeOffer(id = null) {
    loadingrUpgrade.value = true
    const headers = {
        Authorization: 'Bearer ' + salesPerson.value,
        'x-localization': 'da'
    }
    const data = { dead_id: id }
    axios.post(import.meta.env.VITE_BITRIXAPI + 'partner/upgradeAcceptVaekstplus', data, { headers }).then(
        response => {
            loadingrUpgrade.value = false
        },
        (response) => {
            loadingrUpgrade.value = false
            const error = response.data.message
            console.error(error)
        }
    )
}

defineExpose({ showmodel, hidemodal, hidemodaltak, upgradeOfferVaekstplus, acceptUpgradeOffer })
</script>
<style scoped>
#noneligibleFeaturepop .loader,
#noneligibleFeaturepop .loader:before,
#noneligibleFeaturepop .loader:after {
  border-radius: 50%;
}

#noneligibleFeaturepop .loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  transform: translateZ(0);
}

#noneligibleFeaturepop .loader:before,
#noneligibleFeaturepop .loader:after {
  position: absolute;
  content: '';
}

#noneligibleFeaturepop .loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  transform-origin: 5.2em 5.1em;
  animation: load2 2s infinite ease 1.5s;
}

#noneligibleFeaturepop .loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  transform-origin: 0px 5.1em;
  animation: load2 2s infinite ease;
}

@keyframes load2 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.text-green {
  color: #4DCF55;
}
</style>
